import { useEffect } from 'react';
import UI from 'stores/ui';
import { CustomerTypeEnum } from 'types/customer';

export function useLogo(params: { showLogo?: boolean; customerType?: CustomerTypeEnum }) {
    const { showLogo, customerType } = params;

    useEffect(() => {
        // 只有在showLogo存在的时候才使用UI.setShowLogo, 否则使用默认是否展示logo的逻辑
        if (typeof showLogo === 'boolean') {
            UI.setShowLogo(showLogo);
        }

        UI.setLogoCustomerType(customerType);
    }, [showLogo, customerType]);

    return {
        customerType
    };
}
